import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AdminPanelSettingsTwoToneIcon from '@mui/icons-material/AdminPanelSettingsTwoTone';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionSharpIcon from '@mui/icons-material/DescriptionSharp';
import MapIcon from '@mui/icons-material/Map';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import { Box, CssBaseline, Grid, ThemeProvider, Typography } from "@mui/material";
import bottomWaveDtuRed from "./assets/images/bottom_wave_dtu_red.svg";
import LandingCard from './Components/LandingCard';
import { theme_three } from "./theme_three";
export default function LandingPage() {

    return (
        <ThemeProvider theme={theme_three}>
            <CssBaseline>
                <Box
                    display='flex'
                    flexDirection='column'
                    flexGrow={1}
                    marginX={5}
                >
                    <Box display='flex' height='150px' justifyContent='center' border={0} alignItems='flex-end'>
                        <Typography
                            variant='h2'
                        >
                            BMSnet
                        </Typography>
                    </Box>
                    <Typography textAlign='center' border={0} padding={2} paddingBottom={8}>
                        BMSnet er en cloud-baseret løsning, der er designet til at integrere data fra bygninger med BMS-systemer fra forskellige leverandører.
                        Hver dag indsamles der millioner målinger fra energimålere, driftdata fra ventilations- og køleanlæg, ruminformation fra IBI-installationer samt data fra IoT-sensorer.
                        Systemet integrerer også data fra forskellige offentlige udbydere af energiinformation.
                        Dette inkluderer blandt andet aktuel produktion og priser, men der indhentes også data fra de officielle afregningsmålere hos Energinet.
                        Du kan komme ind i de forskellige dele af systemet herunder.
                    </Typography>
                    <Box display='flex' flexDirection='row' flexGrow={1} alignItems='flex-start' mt={5} border={0}>
                        <Grid
                            container
                            direction='row'
                            justifyContent='space-around'
                            alignItems='flex-start'
                            rowSpacing={6}
                            columnSpacing={8}
                        >
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<DashboardIcon fontSize='large' color='primary' />}
                                    title="Energi Dashboard"
                                    description=""
                                    link={'https://dashboard.cas.dtu.dk'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<SolarPowerIcon fontSize='large' color='primary' />}
                                    title="VE Dashboard"
                                    description=""
                                    link={'https://bmsnet.cas.dtu.dk/vedashboard'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<AccessAlarmIcon fontSize='large' color='primary' />}
                                    title="Alarmer"
                                    description=""
                                    link={'https://bmsnetalarm.cas.dtu.dk'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<ShowChartIcon fontSize='large' color='primary' />}
                                    title="Diagrammer"
                                    description=""
                                    link={'https://bmsnet.cas.dtu.dk/view'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<MapIcon fontSize='large' color='primary' />}
                                    title="Kort"
                                    description=""
                                    link={"https://bmsnet.cas.dtu.dk/maps"}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<AdminPanelSettingsIcon fontSize='large' color='primary' />}
                                    title="Administration"
                                    description=""
                                    link={'https://bmsnet.cas.dtu.dk/admin'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<DescriptionSharpIcon fontSize='large' color='primary' />}
                                    title="Dokumentation"
                                    description=""
                                    link={"https://bmsnet.cas.dtu.dk/documentation/"}
                                />
                            </Grid>
                                <Grid item xs={12} sm={6} md={4} xl={3}>
                                    <LandingCard
                                        icon={<CheckroomIcon fontSize='large' color='primary' />}
                                        title="Skabe"
                                        description="Denne side kan kun tilgås fra DTUs interne netværk."
                                        link={"https://locker.cas.dtu.dk:8340"}
                                    />
                                </Grid>
                            <Grid item xs={12} sm={6} md={4} xl={3}>
                                <LandingCard
                                    icon={<AdminPanelSettingsTwoToneIcon fontSize='large' color='action' />}
                                    title="BMSnet Manager"
                                    description=""
                                    link={"https://bmsman.cas.dtu.dk"}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        position="fixed" width="100vw" height="100vh" top={0} left={0} zIndex={-1}
                        sx={{
                            backgroundImage: `url(${bottomWaveDtuRed})`,
                            backgroundRepeat: "repeat-x",
                            backgroundPosition: "bottom",
                            backgroundSize: "auto 60%"
                        }}
                    />
                </Box>
            </CssBaseline>
        </ThemeProvider>
    )
} 